import { SVGProps } from 'react';
const SvgCheckBig = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m4 12 4.95 4.95L19.556 6.343"
    />
  </svg>
);
export default SvgCheckBig;
